import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const Playlist = createApi({
  reducerPath: "Playlist",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["Playlist"],
  endpoints: (builder) => ({
    getPlaylist: builder.query({
      query: ({ page = 1, limit = 10, search = "" }) =>
        `/api/playlist/get-playlist?page=${page}&limit=${limit}`,
      providesTags: (result, error, { page, limit }) => [
        { type: "Playlist", id: `page-${page}-limit-${limit}` },
      ],
    }),

    addPlaylist: builder.mutation({
      query: (data) => ({
        url: `/api/playlist/create-playlist`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Playlist"],
    }),

    updatePlaylist: builder.mutation({
      query: (data) => ({
        url: `/api/playlist/update-playlist/${data?.id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Playlist"],
    }),

    deletePlaylist: builder.mutation({
      query: (id) => ({
        url: `/api/playlist/delete-playlist/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ["Playlist"],
    }),
  }),
});

export const {
  useGetPlaylistQuery,
  useAddPlaylistMutation,
  useUpdatePlaylistMutation,
  useDeletePlaylistMutation,
} = Playlist;
